






































import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';

export default {
    name: 'CoIslandCreateButton',
    components: {
        CoRoundButton,
        CoDropdown,
        CoDropdownItem,
    },
    data() {
        return {};
    },
    computed: {
        isAdmin() {
            return (this.$store?.state?.me?.Permissions || '').includes('space_admin') || false;
        },
        marketIsEnabled() {
            return this.$store?.state?.space?.MarkeplaceOn || false;
        },
        canPost() {
            return this.$store.state.permissions && this.$store.state.permissions['feed.post'] === true;
        },
        canCreatePages() {
            if (this.$store?.state?.space?.PagesOff) {
                return false;
            }
            return this.$store.state.permissions && this.$store.state.permissions['pages.create'] === true;
        },
        canCreateEvents() {
            if (this.$store.state.space.EventsOff) {
                return false;
            }
            return this.$store.state.permissions && this.$store.state.permissions['events.create'] === true;
        },
    },
    methods: {
        // createPost emit event to parent component
        createPost() {
            this.$emit('createPost');
        },

        createEvent() {
            this.$emit('createEvent');
        },

        createMarketItem() {
            this.$emit('createMarketItem');
        },

        createPage() {
            this.$emit('createPage');
        },
    },
};
